module.exports = __webpack_public_path__ + "img/icon-info-ani.a69ff973.gif";